import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'Abschlussbericht',
  sections: {
    'Vorzeitiges Ende': {
      fields: [
        { id: 'Vorzeitiges Ende.Vorzeitig beendet', control: 'checkbox', initial: false },
        { id: 'Vorzeitiges Ende.Letzter Teilnahmetag', control: 'date' },
        { id: 'Vorzeitiges Ende.Begründung', control: 'text', dictation: true },
      ],
    },
    Beurteilung: {
      fields: [
        { id: 'Beurteilung.Kenntnisse und Fertigkeiten', control: 'text', dictation: true },
        { id: 'Beurteilung.Persönliche Eigenschaften und Stärken', control: 'text', dictation: true },
      ],
    },
    Integrationschancen: {
      fields: [{ id: 'Integrationschancen.Bewertung der Integrationschancen', control: 'text', dictation: true }],
    },
    Beschäftigung: {
      fields: [
        { id: 'Beschäftigung.Beschäftigung aufgenommen', control: 'checkbox', initial: false },
        { id: 'Beschäftigung.Beschäftigungsbeginn', control: 'date' },
        { id: 'Beschäftigung.Firma', control: 'text-or-date' },
      ],
    },
  },
} satisfies FormDefinition
